// 1. add 'is-out' class immediately
// 2. remove 'is-in', 'is-active' class immediately
// 3. wait a duration
// 4. then remove 'is-in', and 'is-out' classes
// returns delay timeout

export default function ($elNext, $elLast, duration, classActive = 'is-active', classIn = 'is-in', classOut = 'is-out', timeout = null) {
	if (timeout) {
		clearTimeout(timeout);
	}

	// prepare last el for outro
	$elLast.classList.add(classOut);
	$elLast.classList.remove(classActive, classIn);

	// prepare next el for intro
	$elNext.classList.add(classActive);

	const returnTimeout = setTimeout(() => {
		$elLast.classList.remove(classIn, classOut);
		$elNext.classList.add(classIn);
	}, duration);

	return returnTimeout;
}
